import { useSyncExternalStore } from 'react';

export function useHashState<T>(
  parser: (v: string) => T | null,
  key: string,
  initialValue: T,
): [T, (value: T) => void] {
  const subscribe = (callback: () => void) => {
    window.addEventListener('hashchange', callback);
    return () => window.removeEventListener('hashchange', callback);
  };

  const getSnapshot = () => {
    const hashParams = new URLSearchParams(window.location.hash.slice(1));
    const str = hashParams.get(key);
    if (str === null) {
      return initialValue;
    } else {
      const value = parser(str);
      return value || initialValue;
    }
  };

  const value = useSyncExternalStore(subscribe, getSnapshot);
  const updateHash = (newValue: T) => {
    const hashParams = new URLSearchParams(window.location.hash.slice(1));
    if (newValue === null || newValue === undefined) {
      hashParams.delete(key);
    } else {
      hashParams.set(key, String(newValue));
    }
    window.history.pushState(null, '', `#${hashParams.toString()}`);

    // Force event for subscribers since replaceState does not trigger hashchange
    window.dispatchEvent(new HashChangeEvent('hashchange'));
  };

  return [value, updateHash];
}

// TODO: Remove this function after one/two months
// This function was born for backward compatibility
// Just follow tsc error and remove the rest of uses
// Eg: `"123456"` => `123456`
export function formatHashString(value: string): string {
  return value.replace(/^"(.*)"$/, '$1');
}
